import pick from 'lodash/pick';
import { IOrganizationModel } from '../model';

export default (self: IOrganizationModel) => {
  return {
    // partner_of lists partners both ways (an org and its partner name each other), so this
    // can only tell organizations with partners from those without
    get orgPartnershipsFilterTags() {
      return [self.partner_of?.length ? 'with-partners' : 'no-partners'];
    },
    get filterTags() {
      return self.orgPartnershipsFilterTags;
    },
    get searchString() {
      const searchFields = ['name', 'shippingLocation', 'external_id'];
      return Object.values(pick(self, searchFields)).join(' ').toLowerCase();
    }
  };
};
